import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import useAxiosInstance from "../lib/useAxiosInstance";

function SirReportModal({ open, onClose, sirReportId }) {
  const axiosInstance = useAxiosInstance();
  const [reportUrl, setReportUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || !sirReportId) return;

    const fetchUrl = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axiosInstance.get(
          `api/powerbi-module/getSirReportUrl/${sirReportId}`
        );
        setReportUrl(res.data?.data?.url || null);
      } catch (err) {
        setError("Failed to load SIR report");
      } finally {
        setLoading(false);
      }
    };

    fetchUrl();
  }, [open, sirReportId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!open) return;
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose && onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 3000,
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 20px",
          background: "#001D30",
        }}
      >
        <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>SIR Report</span>
        <button
          type="button"
          onClick={onClose}
          style={{ background: "transparent", border: "none", cursor: "pointer" }}
        >
          <X color="#fff" size={24} />
        </button>
      </div>

      <div style={{ flex: 1, background: "#fff", position: "relative" }}>
        {loading && (
          <div style={{ display: "flex", height: "100%", alignItems: "center", justifyContent: "center" }}>
            Loading SIR report...
          </div>
        )}
        {error && (
          <div style={{ display: "flex", height: "100%", alignItems: "center", justifyContent: "center", color: "#F87171" }}>
            {error}
          </div>
        )}
        {!loading && !error && reportUrl && (
          <iframe
            title="SIR Report"
            src={reportUrl}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        )}
      </div>
    </div>
  );
}

export default SirReportModal;
